import { useCallback, useContext } from 'react';
import { DefaultDatasetFiltersContext } from '../../../../../../contextProviders/SplashScreenProviders/DatasetProviders/DefaultDatasetFiltersProvider';
import usesFieldInPlates from './usesFieldInPlates';

/**
 * Returns a list of default dataset filters that directly reference the field in any plate
 */
const useGetFieldDefaultDatasetFilterUsage = () => {
  const { defaultDatasetFilters } = useContext(DefaultDatasetFiltersContext);

  const getFieldDefaultDatasetFilterUsage = useCallback(
    (field: string, dataset: string) => {
      return defaultDatasetFilters.filter((df) => {
        if (!df.plates) return false;

        return usesFieldInPlates(df.plates, field, dataset);
      });
    },
    [defaultDatasetFilters],
  );

  return getFieldDefaultDatasetFilterUsage;
};

export default useGetFieldDefaultDatasetFilterUsage;
